import schedulesReducer from "./reducers";
export { default as schedulesTypes } from "./types";
export { default as schedulesActions } from "./actions";
export { default as schedulesOperations } from "./operations";
export default schedulesReducer;
